export const allFalse = [false, false, false]

export function config (enumerable, writable, configurable, value) {
  return { enumerable, writable, configurable, value }
}
